import { IUsageResult} from "./IUsageResult";

export enum IUsageArea {"subject"="subject" ,"assignment"="assignment" ,"notebook"="notebook","studentFolders"="studentFolders","homeSite"="homeSite","staffSite"="staffSite","trainingSite"="trainingSite"};

export default interface ISchoolUsageSummary
{
    datasetId: string;
    datasetCreationDate: Date,
    school: { tenantId: string, schoolCode: string, schoolName: string; };
    results: {[key in IUsageArea]: IUsageResult}
}